import { render, staticRenderFns } from "./EditShopDialogForShop.vue?vue&type=template&id=7634d670&scoped=true&lang=pug&"
import script from "./EditShopDialogForShop.vue?vue&type=script&lang=ts&"
export * from "./EditShopDialogForShop.vue?vue&type=script&lang=ts&"
import style0 from "./EditShopDialogForShop.vue?vue&type=style&index=0&id=7634d670&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7634d670",
  null
  
)

export default component.exports